import React from 'react';
import createReactClass from 'create-react-class';
import Widget from '../common/Widget';
import Gravatar from 'react-gravatar';
import moment from 'moment';
import request from '../../helpers/request';
import dashboardConfig from './config/dashboardConfig';

var NotificationWidget = createReactClass({
  getInitialState() {
    return {
      notifications: []
    };
  },

  getDefaultProps(){
    return {
    };
  },

  componentDidMount() {
    request.get({
      url: dashboardConfig.apiUrl + 'notifications',
      success: notifications => {
        if (this.isMounted()) {
          this.setState({
            notifications: notifications
          });
        }
      }
    });
  },

  render() {
    var notifications = this.state.notifications.map(n => {
      let createdString = moment(n.dateCreated).format('DD.MM.YYYY HH:mm:ss');

      return (
        <li key={n.id} className="message">
          <Gravatar email={n.userEmail} size={50} rating="pg" default="mm" https className="online" />
          <div className="message-text">
            <time>
              {createdString}
            </time> <a className="username">{n.userName}</a> <span><b>{n.title}.</b> {n.message}</span>
          </div>
        </li>
      );
    });

    return (
      <Widget title="Nachrichten" icon="comments" containerClassName="col-sm-12 col-md-12 col-lg-6">
        <div id="chat-body" className="chat-body custom-scroll">
            <ul>
              {notifications}
            </ul>
        </div>
      </Widget>
    );
  }
});

export default NotificationWidget;



// WEBPACK FOOTER //
// ./src/components/dashboard/NotificationWidget.js